import React, { memo, useEffect, createRef, useState, useRef } from "react";
import { connect, useDispatch } from "react-redux";
import { compose } from "redux";
import { createStructuredSelector } from "reselect";
import moment from "moment";
import {
  Alert,
  KeyboardAvoidingView,
  Text,
  TextInput,
  TouchableOpacity,
  View,
  Platform,
  ActivityIndicator, ScrollView, FlatList
} from "react-native";
import { Ionicons } from "@expo/vector-icons";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useParams, useLocation, useHistory } from "../../../services/router";
import ButtonHeader from "../../../components/ButtonHeader";
import Content from "../../../components/Content/Content";
import Button from "../../../components/Button";
import styles from "./styles";
import { makeSelectButtons } from "../../../providers/ButtonsProvider/selectors";
import { makeSelectLocations } from "../../../providers/LocationsProvider/selectors";
import SubTitle from "../../../components/Content/SubTitle";
import ModalTakePicture from "../../../components/ChecklistCard/ModalTakePicture";
import Separator from "../../../components/Separator";
import Control from "../../../components/Control";
import { t } from "../../../services/i18n";
import Paragraph from "../../../components/Content/Paragraph";
import API from "../../../config/api";
import request from "../../../utils/request";
import login from "../../../services/login";
import ModalRead from "../../../components/ChecklistCard/ModalRead";
import { makeSelectUserLocation } from "../../../providers/TrackingProvider/selectors";
import DatePicker from "../../../components/Form/DatePicker";
import ChecklistResponseItem from "../../../components/ChecklistResponseItem";
import EStyleSheet from "react-native-extended-stylesheet";
function Responses({ buttons, locations, userLocations }) {
  const dispatch = useDispatch();
  const { locationId, buttonId, checklistId } = useParams();
  const location = useLocation();
  const history = useHistory();
  const startTimeRef = createRef();
  const endTimeRef = createRef();
  const [dailyShiftReportData, setDailyShiftReportData] = useState([]);
  const [date, setDate] = useState(
    moment(location.state?.reportDate, "YYYY-MM-DD").format("YYYY-MM-DD")
  );
  const [shiftInfo, setShiftInfo] = useState(location?.state?.shiftInfo);
  const [startTime, setStartTime] = useState(moment().format("hh:mm a"));
  const [endTime, setEndTime] = useState(moment().format("hh:mm a"));
  const [note, setNote] = useState("");
  const [name, setName] = useState("");
  const [responses, setResponses] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [btnLoader, setBtnLoader] = useState(false);
  const [modal, setModal] = useState(false);
  const [imageViewModal, setImageViewModal] = useState(null);
  const [image, setImage] = useState(null);
  const currentLocation = locations.find(({ id }) => id === locationId);
  const currentButton = buttons.find((button) => button.id === buttonId);
    console.log(currentLocation, locationId);

  const getShiftInfo = async () => {
    try {
      setIsLoading(true);
      //console.log("Inn");https://devbiz.safebuildingsapp.ca/dataservice/checklist/minimal-response?ajax=true&field1=response&field2=8771164&cache=80871
      const url = `${API()}/dataservice/checklist/minimal-response`;

      const options = {
        url,
        method: "GET",
        params: {
          ajax: true,
          field1: "response",
          field2: checklistId
        }
      };

      const { data } = await request(options);
      console.log(data, "datagetShiftInfo");

      setIsLoading(false);
      if (data) {
        setResponses(data?.content)
      }
    } catch (error) {
      console.log(error, "error");
    }
  }
  useEffect(() => {
    getShiftInfo();
  }, []);


  return (
    <KeyboardAvoidingView behavior="padding">
      <ScrollView
        contentContainerStyle={styles.scrollInner}
        style={{ paddingBottom: 50 }}
      >
        <ButtonHeader
          location={currentLocation?.field2 || currentLocation?.id}
          title={currentButton?.field2}
          context={currentButton?.field3 || ''}
          icon="md-pin"
        />
        <Content>
        <SubTitle title="Response" />
          {isLoading && <ActivityIndicator size="small" color={EStyleSheet.value('$grey')} />}
					{!isLoading && !responses.length && (
						<Paragraph>There is no response for this checklist yet.</Paragraph>
					)}
					<FlatList
						data={responses}
						renderItem={({ item }) => (
							<React.Fragment key={item.id}>
								<ChecklistResponseItem response={item} />
								<Separator flat />
							</React.Fragment>
						)}
					/>
        </Content>
      </ScrollView>
    </KeyboardAvoidingView>
  );
}

const mapStateToProps = createStructuredSelector({
  buttons: makeSelectButtons(),
  locations: makeSelectLocations(),
  userLocations: makeSelectUserLocation(),
});

const withConnect = connect(mapStateToProps);

export default compose(withConnect, memo)(Responses);
